export const fetchsubcategory = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/subcategory-master/`);
    if (!response.ok) {
      throw new Error('Failed to fetch catagory');
    }
    const data = await response.json();
    return data;
    // Extract brand_name from each brand_details object
    // return data.map(item => item.sub_category_details.sub_category_name);
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};